// extracted by mini-css-extract-plugin
module.exports = {"hz-Listing-other-seller-root":"ListingOtherSellerRoot_hz-Listing-other-seller-root__bzhTT"};